const msalConfig = {
    auth: {
        clientId: window["env"].b2b.B2B_SPA_CLIENT_ID,
        authority: window["env"].b2b.B2B_AUTHORITY,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
};
const loginRequest = {
    scopes: [window["env"].b2b.B2B_API_SCOPE]
};
export { msalConfig, loginRequest };
